import { useMemo } from "react";
import { useQuery } from "urql";
import { graphql } from "@acto/gql";
import { User } from "@acto/taskpane/core/domain";

const CurrentUserQuery = graphql(`
  query GetCurrentUser {
    currentUser {
      id
      __typename
      name
      employee {
        id
        name
        __typename
      }
    }
  }
`);

export function useCurrentUser() {
  const [result] = useQuery({ query: CurrentUserQuery });

  const user = useMemo(
    () => (result.data?.currentUser ? User.fromGraphql(result.data.currentUser) : undefined),
    [result.data],
  );

  return { data: user, isPending: result.fetching && !result.data, error: result.error };
}
